import { render, staticRenderFns } from "./imageRecognition.vue?vue&type=template&id=67ede7ce&scoped=true"
import script from "./imageRecognition.vue?vue&type=script&lang=js"
export * from "./imageRecognition.vue?vue&type=script&lang=js"
import style0 from "./imageRecognition.vue?vue&type=style&index=0&id=67ede7ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ede7ce",
  null
  
)

export default component.exports